export const getAddress = store => store.address;
export const isLoaded = store => getAddress(store).isLoaded;
export const getAddresses = store => getAddress(store).addresses;
export const getProvinces = store => getAddress(store).provinces;
